export default __webpack_public_path__ + "static/media/refresh-blue.154deac5.svg";